import PrivateMarketDeals from '../../Shared/PrivateMarketDeals';

const AssetAllocationPrivateMarketDeals = (props) => {
  return <PrivateMarketDeals {...props} />;
};

export default AssetAllocationPrivateMarketDeals;
